
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';

import styles from './styles';

function MyDialogActions(props) {
    return (
        <DialogActions className={props.fullScreen ? props.classes.fullScreen : props.classes.dialog}>
            {props.children}
        </DialogActions>
    );
}

MyDialogActions.propTypes = {
    fullScreen: PropTypes.bool
};

export default withStyles(styles)(MyDialogActions);